var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative w-full max-w-xl px-4 py-8 mx-auto sm:py-16"},[_c('SignIn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }